export enum DeviceTypes {
  LirisV2 = 1,
  OpticV5 = 2,
  ExtV5 = 3,
  PtV5 = 4,
  InclinoV2 = 5,
  LirisV3 = 6,
  InclinoV3 = 7,
  GatewayV3 = 8,
  SpcuV5 = 11,
  DauV5 = 12,
  ExtV3 = 13,
  InclinobiaxisV2 = 14,
  VSensor = 15,
  GSensor = 16,
  Exteg = 17,
  Liris420V3 = 18,
  Expe = 19
}
